import Repo from './Repo.js'

export default class WorkplaceProductRulesRepository extends Repo {
  constructor () {
    super('workplace-product-rules')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q, include) {
    return super.paginate(q, include)
  }
}
